import { CheckoutError, InitialData } from '../../../model'
import {
  createFingerprint,
  requestTokenFromApp,
  setCountry,
  setInitialData,
  setIsPrivateBrowsingMode,
  setIsUserVerifyAuthenticatorAvailable,
  setOAuthParams,
  setReferrer,
} from '../../../state'
import { Country } from '@afterpaytouch/portal-api/types'
import { detectBrowserCapabilities } from '../browserCapabilities'
import { validateInitialData } from '../validation'

export interface SetupRequest {
  initialData: InitialData | null
  country: Country
  referrer: string | null
  isIframe: boolean
}

export interface SetupResult {
  initialData?: InitialData | null
  browserCapabilities?: {
    canSupportBiometric: boolean
    isAuthenticatorAvailable: boolean
    isPrivateBrowsing: boolean
  }
  error: CheckoutError | null
}

export const performInitialSetup = async (request: SetupRequest, dispatch: (action: any) => any): Promise<SetupResult> => {
  const validatedInitialData = validateInitialData(request.initialData)

  const browserCapabilities = await detectBrowserCapabilities(request.isIframe)

  dispatch(setIsPrivateBrowsingMode(browserCapabilities.isPrivateBrowsing))
  dispatch(setCountry(request.country))
  dispatch(setReferrer(request.referrer))

  if (validatedInitialData.error !== null) {
    return {
      error: validatedInitialData.error,
    }
  }

  const { initialData } = validatedInitialData
  dispatch(setInitialData(initialData))

  if (browserCapabilities.canSupportBiometric) {
    dispatch(setIsUserVerifyAuthenticatorAvailable(browserCapabilities.isAuthenticatorAvailable))
  }

  dispatch(
    setOAuthParams({
      clientId: initialData.clientId,
      responseType: initialData.responseType,
      redirectUri: initialData.redirectUri,
      scope: initialData.scope,
      state: initialData.state,
    })
  )

  await Promise.all([dispatch(createFingerprint()), dispatch(requestTokenFromApp())])

  return {
    initialData,
    browserCapabilities,
    error: null,
  }
}
